export const WHATSAPP_NUMBER = "918795447361";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi ScholarPrintHub, I would like an academic support / printing quote."
)}`;

export const CONTACT_EMAIL = "surajdubeyks@gmail.com";
export const BRAND = "ScholarPrintHub";
export const OWNER = "Suraj Dubey";
export const CITY = "Lucknow, Uttar Pradesh, India";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/upload", label: "Upload Document" },
  { to: "/calculator", label: "Price Calculator" },
  { to: "/track", label: "Track Order" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    slug: "thesis-writing",
    title: "Thesis Writing Assistance",
    icon: "book-open",
    tagline: "Chapter-wise structured thesis support with proper citations.",
    bullets: [
      "Chapter-wise thesis support",
      "Literature review writing",
      "Research methodology writing",
      "Results and discussion support",
      "Summary, conclusion, recommendation writing",
      "APA, Vancouver, IEEE, MLA, Bluebook citation support",
    ],
  },
  {
    slug: "synopsis-writing",
    title: "Synopsis Writing",
    icon: "file-text",
    tagline: "Ph.D., M.Sc., nursing, medical, law, and management synopsis.",
    bullets: [
      "Ph.D. / M.Sc. / Nursing / Medical / Law / Management synopsis",
      "Research proposal",
      "Objectives & hypothesis framing",
      "Sample size explanation",
      "Methodology preparation",
      "Reference formatting",
    ],
  },
  {
    slug: "research-paper",
    title: "Research Paper Support",
    icon: "microscope",
    tagline: "Drafting, journal formatting, and reference correction.",
    bullets: [
      "Research paper & review paper drafting",
      "Abstract and keyword writing",
      "Introduction and methodology support",
      "Results and discussion formatting",
      "Journal template formatting",
      "Citation, reference & cover letter support",
    ],
  },
  {
    slug: "assignment",
    title: "Assignment & Project Work",
    icon: "clipboard-list",
    tagline: "College assignments, MBA/engineering/nursing projects.",
    bullets: [
      "College assignments & practical files",
      "MBA / Engineering project reports",
      "Nursing care plans",
      "Law assignments & B.Ed. lesson plans",
      "Internship & seminar reports",
      "Research paper review assignments",
    ],
  },
  {
    slug: "formatting",
    title: "Formatting Service",
    icon: "align-left",
    tagline: "University-style formatting, margins, ToC, references.",
    bullets: [
      "University format correction",
      "Margin, font, spacing correction",
      "Heading styles & captions",
      "Table of contents, list of tables & figures",
      "Page numbering & reference formatting",
      "Word to PDF conversion",
    ],
  },
  {
    slug: "plagiarism-check",
    title: "Plagiarism Check",
    icon: "shield-check",
    tagline: "Similarity review, ethical paraphrasing, citation fixes.",
    bullets: [
      "Similarity report support",
      "Source-wise similarity review",
      "Ethical paraphrasing",
      "Citation & reference addition",
      "Grammar & academic language improvement",
      "Originality improvement through referencing",
    ],
  },
  {
    slug: "printing-binding",
    title: "Printing & Binding",
    icon: "printer",
    tagline: "Spiral, soft, hard, leather binding & golden embossing.",
    bullets: [
      "Thesis / dissertation / synopsis printing",
      "Spiral, soft, hard, leather binding",
      "Golden & silver embossing",
      "Spine printing & premium paper options",
      "Colour and black-and-white printing",
      "Final thesis delivery",
    ],
  },
  {
    slug: "dissertation",
    title: "Dissertation Support",
    icon: "graduation-cap",
    tagline: "End-to-end dissertation editing, formatting, printing.",
    bullets: [
      "Chapter-level editing",
      "Data presentation formatting",
      "Reference correction",
      "Final PDF prepared",
      "Hard-bound copies with embossing",
      "Doorstep delivery in India",
    ],
  },
  {
    slug: "doorstep-delivery",
    title: "Doorstep Delivery",
    icon: "truck",
    tagline: "Packed, tracked, and delivered across India.",
    bullets: [
      "Careful packaging for printed thesis",
      "Local Lucknow delivery",
      "Standard India delivery",
      "Express delivery",
      "Courier tracking",
      "Proof approval before printing",
    ],
  },
];

export const PACKAGES = [
  {
    slug: "synopsis",
    name: "Synopsis Package",
    tag: "For Ph.D. / M.Sc. proposals",
    price: "Custom quote",
    features: [
      "Topic refinement",
      "Objectives & hypothesis",
      "Review of literature",
      "Methodology & sample size explanation",
      "References & formatting",
      "Final Word / PDF",
    ],
  },
  {
    slug: "research-paper",
    name: "Research Paper Package",
    tag: "Journal-ready manuscript",
    price: "Custom quote",
    features: [
      "Abstract & keywords",
      "Introduction & methodology",
      "Result and discussion formatting",
      "Citation correction",
      "Reference formatting",
      "Journal template formatting",
    ],
  },
  {
    slug: "formatting",
    name: "Thesis Formatting Package",
    tag: "University-ready final PDF",
    price: "Custom quote",
    features: [
      "Complete formatting",
      "Page numbering",
      "Table of contents",
      "List of tables & figures",
      "Citation correction",
      "Final PDF prepared",
    ],
  },
  {
    slug: "submission",
    name: "Final Thesis Submission",
    tag: "Most popular",
    price: "Custom quote",
    features: [
      "Formatting & plagiarism check support",
      "Citation correction",
      "Final PDF",
      "3 hard-bound copies",
      "Golden embossing",
      "Doorstep delivery",
    ],
    highlight: true,
  },
  {
    slug: "printing",
    name: "Printing & Binding",
    tag: "Ready-made PDF? Print & bind.",
    price: "From ₹100 / copy",
    features: [
      "PDF printing",
      "Spiral or hard binding",
      "Cover & spine printing",
      "Packaging",
      "Local / India delivery",
      "Real-time cost calculator",
    ],
  },
];
